import { Link, Stack, Typography } from '@mui/material';

const TermsContent = ({ containerProps }) => {
  return (
    <Stack spacing={2} {...containerProps}>
      <Typography>
        1. Agreement. This Terraboost Advertising Terms and Conditions
        (“Agreement”) contains the parties’ full and complete agreement and
        understanding with respect to the relationship between Advertiser and
        Terraboost and shall govern all Advertising Agreements and purchase
        orders of Advertiser. You understand and agree that either by executing
        an Advertising Agreement or by otherwise obtaining Advertising Services
        (as defined below) from Terraboost, You accept and are bound by the
        terms and conditions of this Agreement. Capitalized terms not defined in
        this Agreement shall have the meanings ascribed to them in the
        Advertising Agreement.
      </Typography>
      <Typography>
        2. Payments, Extensions and Cancellation.
        <ol type="a">
          <li>
            Each Advertising Agreement is noncancellable during its initial
            Campaign Term. The Ad Production Fee is payable the date Advertiser
            signs the Advertising Agreement. If the Advertising Fee is not paid
            in full when the Advertising Agreement is signed, it is payable
            monthly in advance, beginning on the date stated in the Advertising
            Agreement. Account Holder authorizes Terraboost to charge Account
            Holder’s credit/debit card or debit the authorized bank account for
            the full amount of the Ad Production Fee and initial Advertising Fee
            payment when Terraboost accepts the Advertising Agreement and for
            the remainder of the Advertising Fee monthly as stated in the
            Advertising Agreement, or in full upon Terraboost acceptance of the
            Advertising Agreement if Advertiser has elected to prepay the full
            amount of the Advertising Fee.
          </li>
          <li>
            When Terraboost accepts the Advertising Agreement, Terraboost will
            send You portal setup instructions to Your Designated E-mail
            Address. You will use the customer portal (“Your Portal”) for
            communication and notifications regarding Advertiser’s artwork and
            account.
          </li>
          <li>
            If Your Initial Term is 6 months or longer and You have elected to
            prepay the full amount due for the Campaign Term, the total
            Advertising Fee payable for the Campaign Term will be reduced by
            10%. The Ad Production Fee is not discountable. If You elect to
            prepay the full amount, You authorize Terraboost to charge Your
            credit/debit card or debit Your authorized bank account for the full
            amount due for the Campaign Term upon Terraboost acceptance of the
            Advertising Agreement.{' '}
          </li>
          <li>
            After the Campaign Term, unless You notify Terraboost at least 45
            days prior to the end of the Campaign Term that You elect not to
            extend the Campaign Term, Your Advertising Agreement becomes a
            month-to-month agreement that You may cancel anytime by logging into
            the advertising portal and following the cancellation prompts. Your
            monthly rate will be the same monthly rate You paid during the
            Campaign Term (without the “paid in full” discount). Your
            cancellation will be effective as of the end of the billing cycle
            which begins after Your cancellation request is received by
            Terraboost (the “Cancellation Date”).{' '}
          </li>
          <li>
            After the initial Campaign Term, You may notify Terraboost that You
            elect to extend the Campaign Term and prepay one or more successive
            consecutive renewal terms, each of which will be for the same number
            of months as Your initial Campaign Term. If You elect to prepay,
            Your monthly rate will be the same monthly rate You paid during the
            Initial Term (including any applicable prepayment credit). If You
            elect to prepay the full amount for a renewal term, You will notify
            Terraboost of Your election in which event You authorize Terraboost
            to charge Your credit/debit card for the full amount due for such
            renewal term on the commencement date of such renewal term.
          </li>
          <li>
            You acknowledge that You are aware that Terraboost has expended and
            incurred significant resources and expenses in connection with the
            procurement of this Agreement, including, without limitation, the
            payment by Terraboost of venue fees and commissions and similar
            fees. Accordingly, You agree not to challenge any payment made
            hereunder, whether by credit card, check or ACH, except in the case
            of a material breach of this Agreement by Terraboost which is not
            cured within thirty (30) days after written notice thereof is
            provided to Terraboost at its principal executive office.
          </li>
        </ol>
      </Typography>
      <Typography>
        3. Definitions. “Effective Date” means the date the Advertising
        Agreement is signed by an authorized signatory of Terraboost. “Campaign
        End Date” means the date Terraboost has performed its obligations
        pursuant to the Advertising Agreement or such earlier date as provided
        in Section 13. The “Network” means the network of hand sanitizing
        displays (each, a “Display”) operated and managed by Terraboost, its
        partners, resellers, or designees. “Advertising Content” means the
        artwork, text, graphics and media files, in such format as Terraboost
        may designate from time to time, that You supply to Terraboost for
        publication on certain Displays in the Network. “Advertising Services”
        means Terraboost incorporation, display, and publication of Your
        Advertising Content on certain Displays in the Network, in the manner
        and for the time period(s) set forth in the Advertising Agreement.
        Unless expressly set forth to the contrary in the Advertising Agreement,
        the Advertising Services do not include any guaranteed number of
        impressions, sales, leads generated, or leads closed.
      </Typography>
      <Typography>
        4. Advertising Services. Subject to Your compliance with this Agreement
        and payment of all applicable fees, Terraboost will perform the
        Advertising Services during the term of the Advertising Agreement, in
        the manner set forth in the Advertising Agreement. You hereby grant to
        Terraboost a royalty-free, worldwide, non-exclusive license to use,
        perform, distribute, display, transmit, modify, and reproduce the
        Advertising Content as reasonably required to enable Terraboost to
        perform the Advertising Services. Without limiting the foregoing, You
        understand and agree as follows: (i) that the Network utilizes a variety
        of sizes for Advertising Content, and that Terraboost will have the
        right to size Advertising Content as it sees fit, unless otherwise
        specifically set forth to the contrary in the Advertising Agreement;
        (ii) that Terraboost will have the right (but not the obligation) to
        re-size Advertising Content to fit Displays of different sizes; (iii)
        that the process of affixing “skins” to Displays is an imperfect
        process, and that Terraboost will therefore not be responsible or liable
        to You for imperfect applications; and (iv) that Terraboost may reduce
        the quantity of actual Network locations for the Advertising Content
        while increasing the number of Displays on which the Advertising Content
        is displayed, so long as the total number of Displays contracted for in
        the Advertising Agreement is met.
      </Typography>
      <Typography>
        5. Interest. All fees payable under this Agreement are net amounts and
        are payable in full, without deductions for any sales, use, excise,
        value-added, withholding or similar taxes or duties that may be
        applicable. You will be responsible for, and will promptly pay, all
        taxes and duties of any kind associated with this Agreement, except for
        taxes based on Terraboost net income. Terraboost may, without prejudice
        to any other rights or remedies, at its option, charge You interest on
        any past due payments at one and one half (1.5%) percent per month,
        calculated in US dollars, or the maximum rate permitted by law,
        whichever is less, and to additionally charge all expenses of recovery.
      </Typography>
      <Typography>
        6. Advertising Submission. You will deliver the Advertising Content to
        Terraboost at least fifteen (15) days prior to the scheduled date of
        first publication of the Advertising Content on the Network (the
        “Submission Deadline”). Any changes You wish to make to the Advertising
        Content must be made by You prior to the Submission Deadline. You will
        ensure that Your Advertising Content complies with any creative
        requirements or other specifications set forth in the Advertising
        Agreement. In the event that You fail to provide the Advertising Content
        as required under this Section or if Terraboost or Your selected Venue
        delays approval or does not approve your Advertising Content: (i)
        Terraboost shall not be liable to You or any third party for any delay
        or failure in the performance of the Advertising Services; and (ii) to
        the extent that Terraboost is required to expend time, effort, or
        resources in order to complete or finalize the Advertising Content, You
        agree to reimburse Terraboost for such costs, as invoiced to You on a
        time and materials basis.
      </Typography>
      <Typography>
        7. Limitations. Advertising Content may not contain, advertise, or
        otherwise be related to content that: (i) is obscene, defamatory,
        offensive, libelous, slanderous, untrue, profane, indecent, or unlawful;
        (ii) infringes or misappropriates the intellectual property rights of
        any third party anywhere in the world; (iii) amounts to an unfair trade
        practice or misrepresentation, (iv) constitutes an investment
        advertisement within the meaning of the Financial Services Act 1986; (v)
        contains computer viruses, worms, Trojan horses, spyware, or the like;
        (vi) does not comply with all applicable rules, regulations, laws and
        industry codes of conduct (including, without limitation, codes under
        the general supervision of the American Association of Advertising );
        (vii) is competitive with Terraboost or its location partners’ products
        or services; or (viii) promotes gambling, contraband, narcotics,
        pharmaceuticals, firearms, alcohol, tobacco, financial services, legal
        services or any other product or activity in a manner that is illegal,
        or which would subject Terraboost to regulation, regulatory oversight or
        penalty in any jurisdiction. Terraboost may, but is under no obligation
        to, review the Advertising Content, and may edit, remove, or refuse to
        make the Advertising Content available on the Network, in whole or in
        part and without the requirement of notice, if Terraboost determines, in
        its sole discretion, either that (1) the Advertising Content violates
        any of the foregoing limitations or (2) the owner(s) of the location(s)
        where one or more Displays reside may object to or refuse to authorize
        the placement of the Advertising Content in that location. In the event
        that Terraboost rejects Your Advertising Content in accordance with the
        foregoing sentence, You can re-submit new Advertising Content at any
        time up to the creative submission deadline. If the Ad Submission
        Deadline has passed, Terraboost will use commercially reasonable efforts
        to coordinate an extension of the Ad Submission Deadline in order to
        accommodate You. If this is not possible, You may re-book substitute
        advertising of the same value within six (6) months, provided Terraboost
        has advertising space available that has not already booked. Terraboost
        will place Your Advertising Content on Displays (and on Networks) that
        are available at the time that Your campaign is running. If, for any
        reason, the number of available Displays/Networks is not sufficient to
        complete Your campaign within the time allotted, Terraboost may, at its
        discretion, do one or more of the following: (i) extend the campaign
        until the campaign is complete; (ii) substitute similar Network(s) for
        the Network(s) stated in the Advertising Agreement, as permitted in
        Section 2, above; or (iii) end the campaign at the designated time, and
        provide You with a pro-rata refund for any portion of the Advertising
        Services which were not performed. You acknowledge and agree that
        Terraboost exercise of any of its rights under this Section shall not
        constitute a breach of this Agreement, or otherwise entitle You to any
        legal or equitable remedy (including any credits or refunds, except as
        otherwise expressly defined herein).
      </Typography>
      <Typography>
        8. Intellectual Property. As between You and Terraboost: (i) You own and
        retain all right, title and interest in and to the Advertising Content,
        and all intellectual property rights therein; and (ii) Terraboost owns
        and retains all right, title and interest in and to the Network, and all
        intellectual property rights therein.
      </Typography>
      <Typography>
        9. Your Warranties. You represent and warrant that: (i) You have full
        corporate rights, power, and authority to enter into this Agreement,
        execute the Advertising Agreement, grant the rights and licenses that
        You purport to grant to Terraboost hereunder, and to perform all acts
        required of You hereunder; (ii) You own or have obtained all rights,
        title, and licenses (including, without limitation, all necessary third
        party permissions and consents) necessary to provide the Advertising
        Content to Terraboost, and to enable Terraboost to perform the
        Advertising Services without the requirement of paying any additional
        fees, royalties, or compensation to any third party; (iii) Your
        Advertising Content complies with all applicable laws, rules, and
        regulations; (iv) Your Advertising Content does not and will not violate
        the terms of Section 7, above, (v) Your advertising and communications
        related thereto will in all respects comply with all laws, rules and
        regulations applicable to texting and SMS communications, including but
        not limited to the Telephone Consumer Protection Act (TCPA) and federal,
        state and local privacy laws. You acknowledge and agree that, as between
        You and Terraboost, You will be solely responsible for the products or
        services You are advertising via this Agreement, and that Terraboost
        will have no liability with respect thereto.
      </Typography>
      <Typography>
        10. Terraboost Warranties; Disclaimer. Terraboost represents and
        warrants to You that Terraboost has full corporate rights, power, and
        authority to enter into this Agreement, execute the Advertising
        Agreement, and to perform all acts required of it hereunder. THIS
        LIMITED WARRANTY IS IN LIEU OF, AND TERRABOOST EXPRESSLY DISCLAIMS, ALL
        OTHER WARRANTIES AND CONDITIONS WITH RESPECT TO THIS AGREEMENT, THE
        ADVERTISING AGREEMENT AND THE ADVERTISING SERVICES, WHETHER EXPRESS OR
        IMPLIED, INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
        FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT, AND ANY WARRANTIES OR
        CONDITIONS ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE.
        TERRABOOST MAKES NO GUARANTEES CONCERNING THE ULTIMATE VALUE TO YOU OF
        THE ADVERTISING SERVICES.
      </Typography>
      <Typography>
        11. Limitation of Liability. TERRABOOST TOTAL LIABILITY TO YOU, FROM ALL
        CAUSES OF ACTION AND UNDER ALL THEORIES OF LIABILITY, WILL BE LIMITED TO
        AND WILL NOT EXCEED THE AMOUNTS PAID TO TERRABOOST BY YOU PURSUANT TO
        THE ADVERTISING AGREEMENT GIVING RISE TO THE LIABILITY. IN NO EVENT WILL
        TERRABOOST BE LIABLE TO YOU FOR ANY SPECIAL, INCIDENTAL, EXEMPLARY,
        PUNITIVE OR CONSEQUENTIAL DAMAGES (INCLUDING LOSS OF USE, DATA, BUSINESS
        OR PROFITS) RELATED TO THIS AGREEMENT OR THE USE OR QUALITY OF THE
        ADVERTISING SERVICES, OR FOR THE COST OF PROCURING SUBSTITUTE SERVICES,
        WHETHER SUCH LIABILITY ARISES FROM ANY CLAIM BASED UPON CONTRACT,
        WARRANTY, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHERWISE,
        AND WHETHER OR NOT TERRABOOST HAS BEEN ADVISED OF THE POSSIBILITY OF
        SUCH LOSS OR DAMAGE.
      </Typography>
      <Typography>
        12. Indemnification. Terraboost agrees to indemnify, defend, and hold
        You harmless from and against any and all claims, proceedings, demands,
        damages, costs, expenses, or losses (including, without limitation,
        court costs and attorneys’ fees) arising out of or in connection with:
        (i) Terraboost material breach of this Agreement and (ii) its Network.
        You agree to indemnify, defend, and hold harmless Terraboost from and
        against any and all claims, proceedings, demands, damages, costs,
        expenses, or losses (including, without limitation, court costs and
        attorneys’ fees) arising out of or in connection with: (i) Your breach
        of this Agreement (including, without limitation, Your warranties in
        Section 9); (ii) Your Advertising Content and its compliance with TCPA
        and applicable privacy laws; (iii) the display of Your Advertising
        Content on the Network; (iv) the products or services which are the
        subject of the Advertising Content (including, without limitation, any
        warranty, product liability, claims of misrepresentation or false
        advertising, personal injury, property damage, or other damages or
        losses which are based upon or arise out of such products or services);
        (v) non-payment, late payment, check provided with insufficient funds
        for coverage, or challenge of a credit card payment; (vi) any other act
        or omission by or on behalf of Advertiser or its affiliates; and (vii)
        any and all claims, actions, suits, proceedings, demands, assessments,
        judgments, settlements, costs and expenses incidental to any of the
        foregoing, including, without limitation, claims based on violation of a
        third party’s intellectual property rights. The indemnity obligations of
        Advertiser shall survive the termination or expiration of this
        Agreement.
      </Typography>
      <Typography>
        13. Term and Termination. The term of this Agreement shall begin on the
        Effective Date, and unless earlier terminated pursuant to this Section,
        shall automatically continue pursuant to Section 2. Either party may
        terminate this Agreement and the Advertising Agreement if the other
        party breaches any material term or condition hereof and the breaching
        party cannot or fails to cure such breach within thirty (30) days
        following written notice to such party. Upon the expiration or
        termination of this Agreement or the Advertising Agreement: (i) all
        amounts You owe to Terraboost which have not yet been paid will become
        immediately due and payable; (ii) Terraboost obligation to perform the
        Advertising Services will immediately expire; (iii) Terraboost will
        promptly remove Your Advertising Content from the Network; and (iv) You
        will return and make no further use of any Confidential Information. For
        the sake of clarity, You understand and agree that if You terminate (or
        attempt to terminate) this Agreement or the Advertising Agreement for
        any reason other than for Terraboost breach, You will still owe to
        Terraboost all fees set forth in the Advertising Agreement, and all such
        fees will become immediately due and payable, even if the Advertising
        Services associated with such fees have not yet been performed. The
        rights and obligations of the parties under Sections 5 through 15 will
        survive the expiration or termination of this Agreement or the
        Advertising Agreement for any reason. Terraboost shall have the right to
        terminate this Agreement without liability of any kind to Advertiser and
        to retain all funds previously paid to it hereunder and collect all
        funds owed to it hereunder with respect to the then-current term of this
        Agreement in the event of a breach of this Agreement by the Advertiser,
        including, without limitation, any non-payment of funds when due, check
        provided with insufficient funds for coverage or challenge of a credit
        card payment, which is not cured within ten (10) days after written
        notice thereof is provided to the Advertiser. The rights and remedies of
        Terraboost hereunder are cumulative and in addition to all other rights
        and remedies available to Terraboost at law or in equity.
      </Typography>
      <Typography>
        14. Confidential Information. For the purposes of this Agreement,
        “Confidential Information” means any non-public business or technical
        information, including, without limitation, information relating to
        business processes, operations, product and services plans, costs,
        prices, marketing plans, business opportunities, personnel, research,
        development or know-how, which: due to the nature of the information, a
        person exercising reasonable business judgment would understand such
        information to be confidential or proprietary. The terms of the
        Advertising Agreement are Terraboost Confidential Information. You agree
        that You will not use the Terraboost Confidential Information except for
        the purposes of performing Your obligations and exercising Your rights
        under this Agreement and will not disclose such Terraboost Confidential
        Information to any third party. Notwithstanding the foregoing, either
        party may disclose the Confidential Information to its trustees,
        directors, officers, employees, legal counsel, advisers and agents
        (together “Representatives”) to the extent reasonably required for the
        purposes of performing Your obligations and exercising Your rights under
        this Agreement; provided, however, that each such Representative must be
        subject to binding use and nondisclosure restrictions at least as
        protective as those set forth herein, and that each party remain
        responsible for the acts and omissions of its Representatives under this
        Section. Each Party shall use commercially reasonable efforts to
        maintain the confidentiality of the Confidential Information in its
        possession or control, which efforts will in no event be less than the
        efforts that each Party ordinarily uses to protect its own confidential
        information of similar nature and importance. You acknowledge that
        reports generated as a result of Terraboost performance of the
        Advertising Services may be used, displayed, and distributed by
        Terraboost in any manner it deems appropriate, in Terraboost sole
        discretion, provided that Your Advertising Content and legal name will
        not be associated with such data.
      </Typography>
      <Typography>
        15. Nondisparagement. Each party agrees not to make statements or
        representations, or otherwise communicate, directly or indirectly, in
        writing, orally, or otherwise, or take any action which may, directly or
        indirectly, disparage the other party. In the event of any breach or
        threatened breach of this Section 15, each party will be entitled to
        seek monetary damages and/or equitable relief, including an injunction
        or specific performance (without posting any bond and without proof of
        actual damages), in addition to all other remedies hereunder, at law or
        in equity. Notwithstanding the foregoing, nothing in this Agreement
        shall preclude either party from making truthful statements that are
        required by applicable law, regulation or legal process.
      </Typography>
      <Typography>
        16. No Cancellation. This Agreement may not be canceled by Advertiser
        during the initial Campaign Term and, except as expressly provided
        herein, amounts paid by Advertiser, including, without limitations, Ad
        Production Fees or charges, are not refundable, in whole or in part, in
        each case, for any reason. Without limiting the generality of the
        preceding sentence, this Agreement may not be canceled by Advertiser
        and, except as expressly provided herein. Amounts paid by Advertiser are
        not refundable, in whole or in part, as a result of or in connection
        with the location of the kiosk within the venue, whether or not there
        are always wipes stocked in the kiosk, including the direction it faces
        (both of which will be determined by Terraboost in its sole discretion),
        the timing of installation, actions, taken or omitted to be taken by
        venue owners, venue patrons or other third parties (including, without
        limitation, with respect to the maintenance or stocking of the kiosk),
        any failure by the Advertiser to comply with its obligations hereunder
        (including, without limitation, with respect to its obligations to
        timely provide Advertising Content or other art, graphics or
        information) and actions taken by or on behalf of Terraboost as a result
        of such non-compliance, sales or other leads generated by the
        advertisements not meeting Advertiser’s expectations, the Advertiser not
        receiving or maintaining a copy of the Agreement following its execution
        hereof, or the Advertiser’s desire to cancel this Agreement for any
        other reason.
      </Typography>
      <Typography>
        17. Advertising Content. Advertiser agrees to provide Advertising
        Content (or any necessary logos, images and verbiage for Terraboost to
        produce said Advertising Content) to Terraboost within two (2) weeks of
        the date of this Agreement, and Terraboost shall submit Advertising
        Content proof for Advertiser approval. Advertiser agrees to return proof
        approval, or any request for changes, to Terraboost within five (5)
        business days of receipt of proof. Advertiser is limited to one
        corrected Advertising Content proof, with additional ad copy changes
        billable at $50 per change. If Advertiser fails to provide Advertising
        Content, or return proof approval or request for changes, within the
        applicable time frames set forth above, Terraboost is hereby authorized,
        in Terraboost sole discretion, to use submitted proof, if any, as
        approved Advertising Content for publication and insertion or substitute
        a generic advertisement of Terraboost choice listing Advertiser as the
        sponsor, in lieu of custom advertisement. Advertiser will be required to
        pay Terraboost an additional production fee of $250 to replace any
        advertisement placed by Advertiser pursuant to the preceding sentence
        with a new advertisement provided by Advertiser in accordance with the
        procedures described above. Advertiser understands and agrees that
        because of differences in equipment, paper, inks and other conditions
        between color proofing and production operations, a reasonable variation
        in color between proofs and the final advertisement published and
        inserted is to be expected and is hereby considered acceptable by
        Advertiser. Terraboost reserves the right to make modifications to
        Advertiser’s ad copy in order to meet the approval of Venue partner.
        Once Your ad is posted, You may make one change to Your ad copy every 3
        months. There is a non-refundable production charge of $250 for each
        additional ad copy change. You are not permitted to distribute materials
        of any kinds onto kiosk such as business cards or brochures, for
        example, without contracting for this service separately.
      </Typography>
      <Typography>
        18. Force Majeure. Terraboost shall not be liable for failure to perform
        under this Agreement if due to any labor disputes, strikes, war, fire,
        flood, accident, materials, pandemic, epidemic, loss of a venue from its
        advertising Network, or other shortages, or any act of God or other
        conditions or circumstances beyond Terraboost control. In such case,
        Terraboost may, in its sole discretion, extend the time for performance,
        substitute other similar venues, or credit pro rata amount to the
        Advertiser (provided, however, that any production fee or charge,
        whether paid at contract signing or otherwise, shall not be subject to
        such credit or taken into account for purposes of determining the amount
        of the pro rata credit). Advertiser acknowledges and agrees that for the
        purposes of allocating the fees charged hereunder, in the case of a
        Combo advertisement placement (Top & Front combination), the Top board
        is allocated at 80% of the total price (less the non-refundable Ad
        Production Fee) and the Front board is allocated at 20% of the total
        price (less the non-refundable Ad Production Fee).
      </Typography>
      <Typography>
        19. Competitive Advertising. Advertiser understands and agrees that
        Terraboost may provide advertising space to businesses that are
        competitive to Advertiser (“competitive advertising”), and that such
        competitive advertising may be in the same venue, provided, however that
        no Advertising for competitors (for example, 2 realtors) shall be placed
        on the same kiosk simultaneously.
      </Typography>
      <Typography>
        20. Conversion to Digital. You understand and agree that Terraboost may
        convert some or all of its current Displays to new digital format
        Displays. If Displays at Your selected Venue(s) are converted to digital
        Displays, Your graphics will be converted to a digital format, and
        Terraboost will provide You with Advertising of an equivalent dollar
        value to the Advertising per the Advertising Agreement based upon
        Terraboost Rate Cards then in effect. In such event, You agree that the
        then-current Terraboost Advertising Terms and Conditions for Digital
        Advertising shall apply.
      </Typography>
      <Typography>
        21. Governing Law; Arbitration. This Agreement shall be governed by and
        construed in accordance with the laws of the State of Wyoming excluding
        its conflicts of law rules and principals. All claims, disputes and
        other matters in question arising out of, or relating to, this Agreement
        or the performance hereof, shall be submitted to, and determined by,
        arbitration if good faith negotiations among the Parties, if any, do not
        resolve such claim, dispute or other matter. Such arbitration shall
        proceed in accordance with the then-current rules for arbitration
        established by Judicial Arbitration Mediation Services, Inc. (“JAMS”),
        unless the Parties mutually agree otherwise, and pursuant to the
        following procedures: (a) each Party shall appoint an arbitrator from
        the JAMS panel of retired judges, and those party-appointed arbitrators
        shall appoint a third arbitrator from the JAMS panel of retired judges
        within ten (10) days; if the party-appointed arbitrators fail to appoint
        a third arbitrator within the ten (10) days, such third arbitrator shall
        be appointed by JAMS in accordance with its rules; (b) reasonable
        discovery shall be allowed in arbitration; (c) all proceedings before
        the arbitrators shall be held in Cheyenne, Wyoming; (d) the award
        rendered by the arbitrators shall be final and binding, and judgment may
        be entered in accordance with applicable law and in any court having
        jurisdiction thereof; (e) the award rendered by the arbitrators shall
        include (i) a provision that the prevailing party in such arbitration
        recover its costs relating to the arbitration and reasonable attorneys’
        fees from the other party, (ii) the amount of such costs and fees, and
        (iii) an order that the losing party pay the fees and expenses of the
        arbitrators, to the extent permissible under applicable law. The
        arbitrator shall by the agreement of the Parties expressly be prohibited
        from awarding punitive or special damages in connection with any claim
        being resolved by arbitration hereunder. EACH PARTY EXPRESSLY AND
        IRREVOCABLY AGREES THAT ARBITRATION AS PROVIDED IN THIS SECTION 21 IS
        THE EXCLUSIVE DISPUTE RESOLUTION PROCESS IN ANY ACTION RELATING TO OR
        ARISING OUT OF THIS AGREEMENT AND WAIVES ANY RIGHT TO ANY OTHER DISPUTE
        RESOLUTION PROCESS, INCLUDING BUT NOT LIMITED TO: i) TRIAL BY JURY, ii)
        THE RIGHT TO LITIGATE IN COURT OR IN AN ARBITRATION PROCEEDING ANY
        DISPUTE AS A CLASS ACTION, EITHER AS A MEMBER OF A CLASS OR AS A
        REPRESENTATIVE, OR iii) TO ACT AS A PRIVATE ATTORNEY GENERAL. The United
        Nations Convention on Contracts for the International Sale of Goods will
        not apply.
      </Typography>
      <Typography>
        22. Additional Services. From time to time, Terraboost may, in its
        discretion, offer to provide Advertiser with additional services
        (collectively, “Other Services”), which Other Services may include,
        without limitation, services related to “Online Listings Management,”
        review monitoring, analytics, social media management, social media
        advertising, other online advertising, and other similar services. To
        the extent any Other Services are offered to, and accepted by,
        Advertiser, the terms and provisions of such Other Services, including,
        without limitation, the term of the agreement pertaining to such Other
        Services, shall be the same as those set forth in this Agreement, unless
        the parties enter into a written addendum or separate agreement
        governing the Other Services (an “Other Services Contract”) and provided
        that, in any event, the price, if any, to be paid for the Other Services
        shall be mutually agreed to by the parties. Subject to the terms and
        conditions of any applicable Other Services Contract, Terraboost may, in
        its sole discretion and without any liability to Advertiser or any other
        person, terminate or suspend its provision of the Other Services and
        withhold delivery of materials when this Agreement expires or terminates
        or in the event of any late payment, non-payment or any other breach of
        this Agreement by Advertiser. Additionally, Terraboost shall not be
        liable for any delays or non-performance with respect to its obligations
        under this Agreement or with respect to any Other Services if such delay
        or non-performance is caused by activities or factors beyond its
        reasonable control, including, without limitation, delays and
        non-performance caused by viruses, denial of service, other acts or
        omissions (including failures to timely or adequately perform) by
        Internet service providers, Advertiser (including failure by Advertiser
        to timely furnish information or approve or disapprove work), Terraboost
        contractors or other third parties, strikes, lockouts, work slowdowns or
        stoppages, accidents, terrorism, fires, natural disasters and other acts
        of God.
      </Typography>
      <Typography>
        23. Miscellaneous. You may not assign or transfer this Agreement, in
        whole or in part, by operation of law or otherwise, without Terraboost
        prior written consent, and any attempt by You to do so without such
        consent shall be void and of no effect. Except as expressly set forth in
        this Agreement, the exercise by either party of any of its remedies
        under this Agreement will be without prejudice to its other remedies
        under this Agreement or otherwise. The failure by either party to
        enforce any provision of this Agreement will not constitute a waiver of
        future enforcement of that or any other provision. Neither party will be
        liable for any failure or delay in performance caused by reasons beyond
        its reasonable control, and any such failure or delay will not
        constitute a breach of this Agreement. The parties are independent
        contractors, and nothing in this Agreement shall create, or be deemed to
        create, any type or partnership, joint venture, or employer/employee
        relationship between the parties. Any waiver, modification, or amendment
        of any provision of this Agreement will be effective only if in writing
        and signed by authorized representatives of both parties. If any
        provision of this Agreement is held to be unenforceable or invalid, that
        provision will be enforced to the maximum extent possible and that other
        provisions will remain in full force and effect. This Agreement
        (including the attached Advertising Agreement) is the complete
        understanding between the parties regarding its subject matter, and
        supersedes all proposals, understandings or communications between the
        parties, oral or written, regarding its subject matter. Any terms or
        conditions contained in Your purchase order or other ordering document
        that are inconsistent with or in addition to the terms and conditions of
        this Agreement and the attached Advertising Agreement are hereby
        rejected by Terraboost and will be deemed null and of no effect.
      </Typography>
      <Typography align="center">
        Version #11 November 15, 2022. Terraboost Media Inc.
      </Typography>
      <Typography align="center">
        2232 Dell Range Blvd., Suite 202, Cheyenne, Wyoming 82009 Tel:
        877.837.7210
      </Typography>
      <Typography
        component={Link}
        href="https://www.terraboost.com"
        target="_blank"
        align="center"
      >
        www.terraboost.com
      </Typography>
    </Stack>
  );
};

export default TermsContent;
